

class BannerSticky extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const splideElm = this.querySelector('.splide');
    if (!splideElm) return;

    const speed = parseInt(splideElm.dataset.speed, 10) || 1;
    const isDesignMode = this.dataset.isdesignmode === 'true';


    // Function to initialize Splide
    const initSplide = () => {
      const splideIns = new Splide(splideElm, {
        type: 'slide',
        drag: 'true',
        focus: 'center',
        arrows: false,
        pagination: false,
        perPage: 1,
        autoWidth: true,
        gap: '20px',
        autoScroll: {
          speed: speed,
        },
        breakpoints: {
          1024: { perPage: 3 },
        },
      });
      splideIns.mount();
    };
    initSplide();
    if (isDesignMode) {
      document.addEventListener('shopify:section:load', initSplide);
      document.addEventListener('shopify:block:select', initSplide);
    }
  }
}

customElements.define('banner-sticky', BannerSticky);


class AutoScroll extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const splideElm = this.querySelector('.splide');
    if (!splideElm) return;

    const speed = parseInt(splideElm.dataset.speed, 10) || 1;
    const isDesignMode = this.dataset.isdesignmode === 'true';

    console.log('Speed:', speed, 'Design Mode:', isDesignMode);

    // Function to initialize Splide
    const initSplide = () => {
      const splideIns = new Splide(splideElm, {
        type: 'loop',
        drag: 'free',
        focus: 'center',
        arrows: false,
        pagination: false,
        perPage: 4,
        autoWidth: true,
        gap: '20px',
        autoScroll: {
          speed: speed,
        },
        breakpoints: {
          1024: { perPage: 3 },
        },
      });
      splideIns.mount(window.splide.Extensions);
      console.log('Splide initialized');
    };

    // Initialize once
    initSplide();

    // Reinitialize when in design mode (to reflect live edits)
    if (isDesignMode) {
      document.addEventListener('shopify:section:load', initSplide);
      document.addEventListener('shopify:block:select', initSplide);
    }
  }
}

customElements.define('auto-scroll', AutoScroll);

const faqItems = document.querySelectorAll('.faq-item');

if (faqItems.length > 0) {
  faqItems.forEach(item => {
    const iconWrap = item.querySelector('.faq-icon-wrap');
    const qus = item.querySelector('.faq-question-wrapper');
    const ans = item.querySelector('.faq-answer');

    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    if (iconWrap && ans && !isTouchDevice) {
      iconWrap.addEventListener('mouseenter', () => {
        if (!item.classList.contains('active')) {
          item.classList.add('active');
          ans.style.maxHeight = ans.scrollHeight + 'px';
        }
      });
    }

    if (qus && ans) {
      qus.addEventListener('click', () => {
        const isActive = item.classList.toggle('active');
        ans.style.maxHeight = isActive ? ans.scrollHeight + 'px' : null;
      });
    }
  });
}

// testimonial slider
function initTestimonialSlider() {
  const testimonialElm = document.querySelector('#testimonialSplide');
  if (!testimonialElm) return;

  const speed = parseInt(testimonialElm.dataset.speed, 10) || 1;
  const isDesignMode = testimonialElm.dataset.isdesignmode === 'true';

  const initSplide = () => {
    if (testimonialElm.splide) testimonialElm.splide.destroy(true);

    const splide = new Splide(testimonialElm, {
      type: 'loop',
      arrows: true,
      pagination: false,
      perPage: 2,
      gap: '20px',
      breakpoints: {
        1199: {
          // perPage: 1.7,
          drag: 'free',
          autoWidth: true,
          focus: 'center',
          arrows: false,
          pagination: false,
          autoWidth: true,
          autoScroll: { speed },
        },
        // 989: { perPage: 1.5 },
        // 768: { perPage: 1 },
      },
      autoScroll: { speed },
    });

    splide.on('mounted', function () {
      const prevArrow = testimonialElm.querySelector('.splide__arrow--prev');
      
      if (prevArrow) prevArrow.style.display = 'none';

    });

    splide.mount(window.splide.Extensions);
    testimonialElm.splide = splide;

    console.log(' Testimonial Splide initialized');
  };

  initSplide();
}

initTestimonialSlider();


document.addEventListener('shopify:section:load', initTestimonialSlider);
document.addEventListener('shopify:block:select', initTestimonialSlider);


// advantage slider
function initAdvantageSlider() {
  const advantageElm = document.querySelector('#advantageSplide');
  if (!advantageElm) return;

  const speed = parseInt(advantageElm.dataset.speed, 10) || 1;
  const isDesignMode = advantageElm.dataset.isdesignmode === 'true';

  console.log('Advantage slider found | speed:', speed, 'designMode:', isDesignMode);

  // destroy existing instance to prevent duplicates
  if (advantageElm.splide) {
    try {
      advantageElm.splide.destroy(true);
    } catch (e) {
      // ignore if destroy fails
      console.warn('Error destroying advantage splide instance', e);
    }
  }

  const splide = new Splide(advantageElm, {
    type: 'loop',
    drag: 'free',
    focus: 'center',
    arrows: false,
    perPage: 3,
    pagination: false,
    autoWidth: true,
    gap: '20px',
    autoScroll: { speed },
    breakpoints: {
      1024: { perPage: 2 },
      768: { perPage: 1 },
    },
  });

  splide.mount(window.splide.Extensions);
  advantageElm.splide = splide;
  console.log('Advantage Splide initialized');
}

initAdvantageSlider();

document.addEventListener('shopify:section:load', initAdvantageSlider);
document.addEventListener('shopify:block:select', initAdvantageSlider);


document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('#scrollToInfoBtn, a[href="#ProductInfoTab"]');
  const target = document.querySelector('.product__info-wrapper'); 

  if (buttons.length > 0 && target) {
    buttons.forEach(btn => {
      btn.addEventListener('click', (e) => {

        e.preventDefault();

        const headerOffset = 150;
        const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      });
    });
  }
});



//timer code


function startShippingTimer() {
  const timerElement = document.querySelector(".next_day_shipping_txt");
  const shippingDayElement = document.querySelector(".shipping_day");
  const alternate_text = document.querySelector(".alternate_text");
  if (!timerElement) return;

  let interval;

  function updateTimer() {
    const nowUTC = new Date();

    // Convert UTC to Pacific Time (handles PST/PDT automatically)
    const nowPST = new Date(nowUTC.toLocaleString("en-US", { timeZone: "America/Los_Angeles" }));

    // Define today's 12 AM and 2 PM in PST
    const startPST = new Date(nowPST);
    startPST.setHours(0, 0, 0, 0);
    const cutoffPST = new Date(nowPST);
    cutoffPST.setHours(14, 0, 0, 0); // 2 PM

    // If it's after 2 PM PST → hide timer and .shipping_day, restart at midnight PST
    if (nowPST >= cutoffPST) {
      timerElement.classList.add("hidden");
      if (shippingDayElement) shippingDayElement.classList.add("hidden");
       if (alternate_text) alternate_text.classList.remove("hidden");

      const nextMidnightPST = new Date(nowPST);
      nextMidnightPST.setDate(nextMidnightPST.getDate() + 1);
      nextMidnightPST.setHours(0, 0, 0, 0);

      const timeUntilNextStart = nextMidnightPST - nowPST;
      clearInterval(interval);
      setTimeout(startShippingTimer, timeUntilNextStart);
      return;
    }

    // Otherwise, show timer and shipping info
    timerElement.classList.remove("hidden");
    if (shippingDayElement) shippingDayElement.classList.remove("hidden");
     if (alternate_text) alternate_text.classList.add("hidden");

    // Time remaining until 2 PM PST
    const diffMs = cutoffPST - nowPST;
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    // Update display text
    timerElement.textContent = `${hours}h ${minutes}m`;
  }

  // Run immediately, then update every second
  updateTimer();
  interval = setInterval(updateTimer, 1000);
}

document.addEventListener("DOMContentLoaded", startShippingTimer);
document.addEventListener('shopify:section:load', startShippingTimer);
document.addEventListener('shopify:block:select', startShippingTimer);


function openTargetFAQ() {
  const item = document.querySelector('.faq-item.open-target');
  if (!item) return;

  const ans = item.querySelector('.faq-answer');
  if (!ans) return;

  item.classList.add('active');
  ans.style.maxHeight = ans.scrollHeight + 'px';
}

const ingredientBtn = document.querySelector('.list-btn');
const targetFAQ = document.querySelector('.faq-item.open-target');  // FIXED

if (ingredientBtn && targetFAQ) {
  ingredientBtn.addEventListener('click', (e) => {
    e.preventDefault();

    const headerOffset = 150;
    const elementPosition = targetFAQ.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });

    setTimeout(() => {
      openTargetFAQ();
    }, 400);
  });
}



  const form = document.querySelector(".product-form");
  const buyNowBtn = form.querySelector(".direct-checkout-btn");

  buyNowBtn.addEventListener("click", function(e) {
    e.preventDefault();

    const variantInput = form.querySelector("input[name='id']");
    if (!variantInput) return;

    const variantId = variantInput.value;

    window.location.href = `/cart/${variantId}:1?checkout`;
  });


